var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFactoryPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#364863"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65516 4.37527C8.3584 3.87491 7.6416 3.87491 7.34484 4.37526L4.11006 9.82939C3.80451 10.3446 4.17133 11 4.76522 11L11.2348 11C11.8287 11 12.1955 10.3446 11.8899 9.82939L8.65516 4.37527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactoryPrice);
export default __webpack_public_path__ + "static/media/icon-factoryPrice.cb67d2c5f653260827bc953bf623bd1a.svg";
export { ForwardRef as ReactComponent };